import React, { useState } from "react";
import { MailCheck, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

const INSTRUMENTS = [["piano", "Piano"], ["guitar", "Guitar"], ["drums", "Drums"], ["voice", "Voice"], ["all", "A bit of everything"]];
const field = "w-full rounded-full border border-border bg-background px-4 py-2.5 text-sm outline-none transition-colors focus:border-primary";

// Mailing-list sign-up. `id` keeps test ids unique when used on the page and in the footer.
export const NewsletterForm = ({ id = "page", compact = false, source = "page", page = "" }) => {
  const [f, setF] = useState({ name: "", email: "", instrument: "" });
  const [state, setState] = useState("idle");
  const [error, setError] = useState("");
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setState("sending"); setError("");
    try { await api.post("/newsletter/subscribe", { ...f, source, page: page || window.location.pathname }); setState("done"); }
    catch (err) { setState("idle"); setError(typeof err.response?.data?.detail === "string" ? err.response.data.detail : "Please check your name, email and instrument."); }
  };
  if (state === "done") return (
    <div className="flex items-start gap-3 rounded-2xl border border-primary/40 bg-primary/10 p-4 text-sm" data-testid={`newsletter-${id}-done`}>
      <MailCheck className="mt-0.5 shrink-0 text-primary" size={20} />
      <p>Nearly there! Check <b>{f.email}</b> and tap the link in my email to confirm. (Have a look in spam if it isn't there in a few minutes.)</p>
    </div>
  );
  return (
    <form onSubmit={submit} className={`grid gap-3 ${compact ? "sm:grid-cols-2" : ""}`} data-testid={`newsletter-${id}-form`}>
      <input required maxLength={60} value={f.name} onChange={set("name")} placeholder="Your first name" aria-label="Your name" className={field} data-testid={`newsletter-${id}-name`} />
      <input required type="email" value={f.email} onChange={set("email")} placeholder="Your email" aria-label="Your email" className={field} data-testid={`newsletter-${id}-email`} />
      <select required value={f.instrument} onChange={set("instrument")} aria-label="Instrument you're interested in" className={field} data-testid={`newsletter-${id}-instrument`}>
        <option value="" disabled>Which instrument interests you?</option>
        {INSTRUMENTS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
      </select>
      <button type="submit" disabled={state === "sending"} data-testid={`newsletter-${id}-submit`}
        className="inline-flex items-center justify-center gap-2 rounded-full bg-primary px-5 py-2.5 text-sm font-bold text-primary-foreground transition-transform hover:-translate-y-0.5 disabled:opacity-60">
        {state === "sending" && <Loader2 size={15} className="animate-spin" />} Keep me in touch
      </button>
      {error && <p className="text-sm text-destructive sm:col-span-2" data-testid={`newsletter-${id}-error`}>{error}</p>}
      <p className={`text-xs text-muted-foreground ${compact ? "sm:col-span-2" : ""}`}>No spam, just offers and updates. Unsubscribe any time with one click.</p>
    </form>
  );
};
